// Mock data for portfolio — auto-generated from import_portfolio.py

export const portfolioData = {
    hero: {
      name: "Gal Harlavan",
      tagline: "Social Media & Marketing Designer · Illustrator",
      profileImage: "https://customer-assets.emergentagent.com/job_design-portfolio-hub-72/artifacts/434ziyoh_363449893_6513960515362751_5543787263734969426_n.jpg"
    },
    categories: [
      {
        id: "gaming",
        title: "Gaming",
        thumbnail: "/covers/gaming.png",
        description: "Game art, character design and illustration"
      },
      {
        id: "social-media",
        title: "Social Media",
        thumbnail: "/covers/social-media.png",
        description: "Instagram grids and social campaigns"
      },
      {
        id: "branding",
        title: "Branding",
        thumbnail: "/covers/branding.png",
        description: "Brand identities, packaging and visual systems"
      },
      {
        id: "illustration",
        title: "Illustration",
        thumbnail: "/covers/illustration.png",
        description: "Hand-drawn art, comics, posters and editorial"
      }
    ],
    projects: {
      gaming: [
        {
          id: "trash-burger",
          slug: "trash-burger",
          title: "Trash Burger",
          image: "/projects/trash-burger/cover.png",
          description: "A vibrant fast food world run by adorable raccoons.",
          tools: [
            "Procreate",
            "Photoshop",
            "Illustrator"
          ],
          tagline: "A vibrant fast food world run by adorable raccoons.",
          overview: "Trash Burger is a game that immerses players in the vibrant world of a bustling fast food restaurant run by adorable raccoons. Players will take on the role of a raccoon employee and must navigate through various challenges to keep the restaurant running smoothly and satisfy hungry customers.",
          role: "Illustration · Character Design",
          year: "2024",
          cover: "/projects/trash-burger/01.jpg",
          gallery: [
            "/projects/trash-burger/02.jpg",
            "/projects/trash-burger/03.jpg",
            "/projects/trash-burger/04.jpg",
            "/projects/trash-burger/05.jpg",
            "/projects/trash-burger/06.jpg",
            "/projects/trash-burger/07.png",
            "/projects/trash-burger/08.png"
          ]
        },
        {
          id: "the-sins",
          slug: "the-sins",
          title: "The Sins",
          image: "/projects/the-sins/cover.png",
          description: "Satan and friends navigating life in the underworld.",
          tools: [
            "Procreate",
            "Photoshop"
          ],
          tagline: "Satan and friends navigating life in the underworld.",
          overview: "As the ruler of Hell, Satan must navigate the challenges of life in the underworld, from maintaining their health and wellbeing to interacting with the denizens of Hell. With the help of his friends and advisors, Satan must make difficult decisions and confront dangerous enemies to maintain his kingdom. During the game, the player will come across different characters that represent different vices and sins, and must decide whether to align with these characters or try and resist their influence. The player will also face moral dilemmas and face difficult choices that affect the course of the game.",
          role: "Illustration · Character Design",
          year: "2023",
          cover: "/projects/the-sins/01.png",
          gallery: [
            "/projects/the-sins/02.jpg",
            "/projects/the-sins/03.png",
            "/projects/the-sins/04.jpg",
            "/projects/the-sins/05.jpg",
            "/projects/the-sins/06.jpg"
          ]
        }
      ],
      socialMedia: [
        {
          id: "true-story-social-media",
          slug: "true-story-social-media",
          title: "True Story",
          image: "/projects/true-story-social-media/cover.png",
          description: "Calm grid, soft palette, AI-blended product story.",
          tools: [
            "Photoshop",
            "Illustrator",
            "AI Tools"
          ],
          tagline: "Calm grid, soft palette, AI-blended product story.",
          overview: "The social media design for True Story explores a grid built around soft, pleasant colors that create a calm and cohesive visual language. The design blends product photography with AI-generated visuals and graphic elements, allowing for playful experimentation while keeping the product clearly visible. The result is a balanced and engaging social presence that highlights the product without overpowering it.",
          role: "Social Media · Graphic Design",
          year: "2026",
          cover: "/projects/true-story-social-media/cover.png",
          gallery: [],
          carousels: [
            {
              title: "Campaign",
              images: [
                "/projects/true-story-social-media/13.png",
                "/projects/true-story-social-media/01.png",
                "/projects/true-story-social-media/02.png",
                "/projects/true-story-social-media/03.png",
                "/projects/true-story-social-media/04.png",
                "/projects/true-story-social-media/05.png",
                "/projects/true-story-social-media/06.png",
                "/projects/true-story-social-media/07.png",
                "/projects/true-story-social-media/08.png",
                "/projects/true-story-social-media/09.png",
                "/projects/true-story-social-media/10.png",
                "/projects/true-story-social-media/11.png",
                "/projects/true-story-social-media/12.png"
              ]
            }
          ]
        },
        {
          id: "deja-blue",
          slug: "deja-blue",
          title: "Deja Blue",
          image: "/projects/deja-blue/cover.png",
          description: "Bold, dynamic, illustrated Instagram identity.",
          tools: [
            "Photoshop",
            "Illustrator",
            "Procreate"
          ],
          tagline: "Bold, dynamic, illustrated Instagram identity.",
          overview: "The Instagram grid for Deja Blue features a vibrant and dynamic visual style that immediately captures attention. It emphasizes a bold color palette and combines illustrated elements with photography and AI-generated visuals, creating a layered and contemporary look while maintaining a cohesive and recognizable brand identity.",
          role: "Social Media · Illustration",
          year: "2023",
          cover: "/projects/deja-blue/01.png",
          gallery: [
            "/projects/deja-blue/02.png",
            "/projects/deja-blue/03.png",
            "/projects/deja-blue/04.png",
            "/projects/deja-blue/05.png",
            "/projects/deja-blue/06.png",
            "/projects/deja-blue/07.png",
            "/projects/deja-blue/08.png",
            "/projects/deja-blue/09.png",
            "/projects/deja-blue/10.png",
            "/projects/deja-blue/11.png",
            "/projects/deja-blue/12.png",
            "/projects/deja-blue/13.png",
            "/projects/deja-blue/14.png",
            "/projects/deja-blue/15.png",
            "/projects/deja-blue/16.png",
            "/projects/deja-blue/17.png",
            "/projects/deja-blue/18.png",
            "/projects/deja-blue/19.png",
            "/projects/deja-blue/20.png",
            "/projects/deja-blue/21.png",
            "/projects/deja-blue/22.png",
            "/projects/deja-blue/23.png",
            "/projects/deja-blue/24.png"
          ]
        },
        {
          id: "imtm-social-media",
          slug: "imtm-social-media",
          title: "IMTM",
          image: "/projects/imtm-social-media/cover.png",
          description: "Mediterranean Tourism Market — cohesive grid, dynamic cutouts.",
          tools: [
            "Photoshop",
            "Illustrator"
          ],
          tagline: "Mediterranean Tourism Market — cohesive grid, dynamic cutouts.",
          overview: "The social media design for the IMTM – International Mediterranean Tourism Market features a cohesive Instagram grid that combines photos from past conferences with smooth graphic elements and dynamic cutouts. The interplay between photography and graphics emphasizes the conference’s innovation and energy, while effectively using the existing brand colors to create a clear and unified visual language.",
          role: "Social Media · Graphic Design",
          year: "2023",
          cover: "/projects/imtm-social-media/01.png",
          gallery: [
            "/projects/imtm-social-media/02.png",
            "/projects/imtm-social-media/03.png",
            "/projects/imtm-social-media/04.png",
            "/projects/imtm-social-media/05.png",
            "/projects/imtm-social-media/06.png",
            "/projects/imtm-social-media/07.png",
            "/projects/imtm-social-media/08.png",
            "/projects/imtm-social-media/09.png",
            "/projects/imtm-social-media/10.png",
            "/projects/imtm-social-media/11.png",
            "/projects/imtm-social-media/12.png",
            "/projects/imtm-social-media/13.png",
            "/projects/imtm-social-media/14.png",
            "/projects/imtm-social-media/15.png"
          ]
        },
        {
          id: "flormar",
          slug: "flormar",
          title: "Flormar",
          image: "/projects/flormar/cover.png",
          description: "A flexible creative system for makeup as everyday self-expression.",
          tools: [
            "Photoshop",
            "Illustrator",
            "AI Tools"
          ],
          tagline: "Makeup as everyday self-expression — a flexible visual storytelling system.",
          overview: "Flormar is an international beauty brand focused on color, creativity, and self-expression through makeup. For this campaign, I developed a creative visual concept built around the idea of makeup as part of everyday life — not just decoration but a tool for expression and mood. The creative system combines bold color palettes, clean typography, and playful storytelling directions that connect beauty products to daily routines, seasonal moods, and emotional experiences. The campaign was designed as a flexible storytelling system, allowing different creative scenarios and visual narratives while maintaining a consistent brand language.",
          role: "Social Media · Art Direction",
          year: "2025",
          cover: "/projects/flormar/cover.png",
          gallery: [],
          carousels: [
            {
              title: "Bold & Playful",
              images: [
                "/projects/flormar/bold-playful/01.png",
                "/projects/flormar/bold-playful/02.png",
                "/projects/flormar/bold-playful/03.png",
                "/projects/flormar/bold-playful/04.png",
                "/projects/flormar/bold-playful/05.png"
              ]
            },
            {
              title: "Soft & Natural",
              images: [
                "/projects/flormar/soft-natural/01.png",
                "/projects/flormar/soft-natural/02.png",
                "/projects/flormar/soft-natural/03.png",
                "/projects/flormar/soft-natural/04.png"
              ]
            },
            {
              title: "Mediterranean Edition",
              images: [
                "/projects/flormar/mediterranean/01.png",
                "/projects/flormar/mediterranean/02.png",
                "/projects/flormar/mediterranean/03.png",
                "/projects/flormar/mediterranean/04.png"
              ]
            },
            {
              title: "Sugar Plum Collection",
              images: [
                "/projects/flormar/sugar-plum/01.png",
                "/projects/flormar/sugar-plum/02.png",
                "/projects/flormar/sugar-plum/03.png",
                "/projects/flormar/sugar-plum/04.png",
                "/projects/flormar/sugar-plum/05.png"
              ]
            }
          ]
        }
      ],
      branding: [
        {
          id: "the-dough-collective",
          slug: "the-dough-collective",
          title: "The Dough Collective",
          image: "/projects/the-dough-collective/cover.png",
          description: "Hand-drawn cookies, playful palette, energetic branding.",
          tools: [
            "Illustrator",
            "Photoshop",
            "Procreate"
          ],
          tagline: "Hand-drawn cookies, playful palette, energetic branding.",
          overview: "\"The Dough Collective\" features bold, hand-drawn cookie illustrations set against a playful color palette. The design combines eye-catching typography with detailed visuals to reflect the brand's energetic and approachable identity, while effectively highlighting new flavors, special events, and promotional offers",
          role: "Branding · Illustration",
          year: "2024",
          cover: "/projects/the-dough-collective/01.png",
          gallery: [
            "/projects/the-dough-collective/02.png",
            "/projects/the-dough-collective/03.png",
            "/projects/the-dough-collective/04.png",
            "/projects/the-dough-collective/05.png",
            "/projects/the-dough-collective/06.png",
            "/projects/the-dough-collective/07.png",
            "/projects/the-dough-collective/08.jpg",
            "/projects/the-dough-collective/09.jpg",
            "/projects/the-dough-collective/10.png",
            "/projects/the-dough-collective/11.jpg"
          ]
        },
        {
          id: "darkmattr",
          slug: "darkmattr",
          title: "Dark Matter",
          image: "/projects/darkmattr/cover.png",
          description: "Activated-charcoal dark chocolate for the alternative scene.",
          tools: [
            "Illustrator",
            "Photoshop"
          ],
          tagline: "Activated-charcoal dark chocolate for the alternative scene.",
          overview: "Dark Matter is a rich, indulgent dark chocolate crafted with activated charcoal to help cleanse your system and combat the effects of a night out. Perfect for those who embrace the alternative scene and live life on the edge, Dark Matter combines bold flavors with detoxifying benefits, offering a delicious way to reset after a wild night. It's more than chocolate—it's your ritual for recovery and indulgence, a unique treat for those who dare to go dark",
          role: "Branding · Packaging",
          year: "2023",
          cover: "/projects/darkmattr/01.png",
          gallery: [
            "/projects/darkmattr/02.png",
            "/projects/darkmattr/03.png",
            "/projects/darkmattr/04.png",
            "/projects/darkmattr/05.png",
            "/projects/darkmattr/06.png"
          ]
        },
        {
          id: "tiffanys-kids",
          slug: "tiffanys-kids",
          title: "Tiffany's & Kids",
          image: "/projects/tiffanys-kids/cover.png",
          description: "Tiffany & Co. luxury sub-brand for affluent kids — a breakfast story.",
          tools: [
            "Illustrator",
            "Photoshop"
          ],
          tagline: "Tiffany & Co. luxury sub-brand for affluent kids — a breakfast story.",
          overview: "luxury sub-brand called \"Tiffneys & Kid\" as part of the well-known Tiffany & Co. brand, targeting affluent children and featuring a breakfast food theme. This concept blends the prestige of Tiffany & Co. with a playful and whimsical twist inspired by breakfast.",
          role: "Branding · Concept Design",
          year: "2023",
          cover: "/projects/tiffanys-kids/01.png",
          gallery: [
            "/projects/tiffanys-kids/02.png",
            "/projects/tiffanys-kids/03.png",
            "/projects/tiffanys-kids/04.png"
          ]
        }
      ],
      illustration: [
        {
          id: "illustrated-background",
          slug: "illustrated-background",
          title: "Illustrated Backgrounds",
          image: "/projects/illustrated-background/cover.png",
          description: "Intricate hand-drawn backgrounds that bring designs to life.",
          tools: [
            "Procreate",
            "Photoshop"
          ],
          tagline: "Intricate hand-drawn backgrounds that bring designs to life.",
          overview: "This page showcases intricate illustrations of backgrounds, adding depth and texture that bring each element of the design to life",
          role: "Illustration",
          year: "2023",
          cover: "/projects/illustrated-background/01.png",
          gallery: [
            "/projects/illustrated-background/02.png",
            "/projects/illustrated-background/03.png",
            "/projects/illustrated-background/04.png"
          ]
        },
        {
          id: "im-okay",
          slug: "im-okay",
          title: "I'm Okay",
          image: "/projects/im-okay/cover.png",
          description: "A comic book about Dizengoff Center teens in the late 2000s.",
          tools: [
            "Procreate",
            "InDesign"
          ],
          tagline: "A comic book about Dizengoff Center teens in the late 2000s.",
          overview: "A comic book tells the story of the Dizengoff Center teens in the late 2000s and reveals the dark and unknown side of the alternative scene.",
          role: "Illustration · Storytelling",
          year: "2023",
          cover: "/projects/im-okay/01.png",
          gallery: [
            "/projects/im-okay/02.png",
            "/projects/im-okay/03.png",
            "/projects/im-okay/04.png",
            "/projects/im-okay/05.png",
            "/projects/im-okay/06.png"
          ]
        },
        {
          id: "posters",
          slug: "posters",
          title: "Posters",
          image: "/projects/posters/cover.png",
          description: "Posters for real and fictional events.",
          tools: [
            "Illustrator",
            "Photoshop"
          ],
          tagline: "Posters for real and fictional events.",
          overview: "This page highlights a collection posters design for real and fictional events",
          role: "Poster Design · Illustration",
          year: "2024",
          cover: "/projects/posters/01.jpg",
          gallery: [
            "/projects/posters/02.png"
          ]
        }
      ]
    },
    about: {
      bio: "Self-motivated team player with strong interpersonal skills, seeking a position in the field of illustration and graphic design. B.DES in Visual Communication from Holon Institute of Technology — I create work across illustration, graphic design, and motion, combining creativity with strategic thinking to deliver designs that tell stories that resonate.",
      skills: [
        "Illustration",
        "AI Tools",
        "Graphic Design",
        "Motion Graphics",
        "UX / UI (Gaming)",
        "Customer Service"
      ],
      software: [
        "Procreate",
        "Photoshop",
        "Illustrator",
        "Figma",
        "InDesign",
        "After Effects",
        "Cinema 4D"
      ],
      experience: [
        {
          title: "Social Media & Marketing Designer",
          company: "THM",
          period: "Jun 2025 — Present"
        },
        {
          title: "Freelance Designer",
          company: "Poster design · Custom art",
          period: "2015 — Present"
        },
        {
          title: "Poster Designer",
          company: "Relevant",
          period: "Dec 2023 — Aug 2024"
        },
        {
          title: "Screen Printing Assistant",
          company: "Holon Institute of Technology",
          period: "Oct 2022 — Mar 2023"
        }
      ],
      education: [
        {
          degree: "B.DES Visual Communication",
          school: "Holon Institute of Technology",
          period: "Oct 2019 — Jul 2023"
        }
      ],
      languages: [
        "Hebrew",
        "English"
      ],
      cvUrl: "https://customer-assets.emergentagent.com/job_design-portfolio-hub-72/artifacts/o0k6kcyo_bwzpbh6t_Gal%20Harlavan%20CV.pdf"
    },
    contact: {
      email: "gal.harlavan@gmail.com",
      phone: "+972 54-338-5662",
      portfolio: "https://galharlavan.myportfolio.com",
      social: {
        instagram: "@evilnoodles666",
        instagramUrl: "https://www.instagram.com/evilnoodles666/",
        behance: "galharlavan",
        portfolio: "galharlavan.myportfolio.com"
      }
    }
  };
